import React, { useEffect, useState } from 'react'
import strings from "../../utils/property-file/setting.json"
import './setting.css'
import packageJson from '../../../package.json';
import "../color.css";
import { useNavigate} from "react-router-dom";
import api from '../../services/api';
import { toast } from 'react-toastify';
import ToggleSettingCard from './ToggleSettingCard'
import SettingsConfirmationModal from './SettingConfirmationModal';
import constants from '../../utils/constants';

export default function Setting() {
  const companyName=localStorage.getItem("company_info");
  const userName=localStorage.getItem("userName");
  const isSuperAdmin = localStorage.getItem("isSuperAdmin");
  const nav = useNavigate();
  const [companySettingList, setCompanySettingList] = useState({});
  const [settingName,setSettingName] = useState('')
  const [isSettingsEdited,setSettingsEdited] = useState(false);
  const isBluewingsCustomer = localStorage.getItem('isBluewingsCustomer')

  useEffect(()=>{
    getSettingsList();
  },[])

  const getSettingsList = async () => {
    try {
      const response = await api.getCompanySettingList();
      if (response && response.data) {
        const data = JSON.parse(response.data);
        setCompanySettingList(data.body);
      } else {
        setCompanySettingList({});
      }
    } catch (error) {
      toast.error(error.message, { toastId: "error6" });
    }
  }
const handleToggle = (settingSlug) => {
  if (!settingSlug) return;
  setSettingsEdited(true);
  setSettingName(settingSlug);
};



  const handleSettingsConfirmationCancel = () =>{
    setSettingsEdited(false)
  }
  
  const handleSettingsConfirmation = ()=>{
    const currentValue = companySettingList[settingName];
  const updatedValue = !currentValue;
    updateSettings(settingName,updatedValue);
  }

   const logout = async () => {
      try {
          let response = await api.logout()
          if(response.success) {
            localStorage.clear();
            nav(constants.navigationLink.loginLink);
          }else{
            toast.error(strings.somethingWentWrongLabel ,{toastId : strings.errorLabel})
          }
        
      } catch (e) {
          toast.error(strings.somethingWentWrongLabel ,{toastId : strings.errorLabel})
          return e.response;
      }
  }
  
  const updateSettings = async (settingSlug,updatedValue)=>{
    try {
      const body = {
        [settingSlug] : updatedValue
      }
      const response = await api.updateCompanySetting(body);
      if(response&&response.data){
           const data = JSON.parse(response.data);
           if(response.success){
            setSettingsEdited(false);
             toast.success(data.body,{ toastId: "error6" })
             setTimeout(()=>{
               logout();
             },1000)
           }else{
             toast.error(data.body,{ toastId: "error6" })
           }
      }
      
    } catch (error) {
       toast.error(error.message, { toastId: "error6" });
    }
  }
console.log("companySettingList",companySettingList);

  return (
    <div >
      <SettingsConfirmationModal
        isSettingsEdited = {isSettingsEdited}
        handleCancel = {handleSettingsConfirmationCancel}
        handleConfirm={handleSettingsConfirmation}
      />
        <div className="setting-details-sub-container mt-3">
        <div className="security-feature">
        {!isBluewingsCustomer ?
        <div className="setting-feature-one">
            <p className='feature-name'>{strings.securityLabel}</p>
            <div className='password-feature row'  onClick={(()=>nav('/change-password'))}>
                <p className='password-change-option col-6 mt-2 p-0'>{strings.passwordLabel}</p>
                 <i className="ri-arrow-right-s-line text-end arrow-setting col-6 mt-2 p-0"></i>
            <div className='feature-separate'></div>
          </div>
        </div> : <p className='feature-name'>{strings.settings}</p>}
        </div>
        <div className='company-settings'>
          {companySettingList && (
            <>
              <ToggleSettingCard
                title={strings.enableAutoCheckoutTitle}
                description={strings.enableAutoCheckout}
                isChecked={companySettingList.enableAutoCheckout}
                settingSlug="enableAutoCheckout"
                onToggle={handleToggle}
              />

              <ToggleSettingCard
                title={strings.allowMultipleCheckInOutTitle}
                description={strings.allowMultipleCheckInOut}
                isChecked={!!companySettingList.allowMultipleCheckInOut}
                settingSlug="allowMultipleCheckInOut"
                onToggle={handleToggle}
              />
               <ToggleSettingCard
                title={strings.isCheckInTimeEditableTitle}
                description={strings.isCheckInTimeEditable}
                isChecked={!!companySettingList.isCheckInTimeEditable}
                settingSlug="isCheckInTimeEditable"
                onToggle={handleToggle}
              />
                <ToggleSettingCard
                title={strings.isCheckOutTimeEditableTitle}
                description={strings.isCheckOutTimeEditable}
                isChecked={!!companySettingList.isCheckoutTimeEditable}
                settingSlug="isCheckoutTimeEditable"
                onToggle={handleToggle}
              />
            </>
          )}
        </div>
          <div className="app-information text-center">
            <p className='info-about-version'>{companyName}</p>
            <p className='info-about-version'>{strings.loggedInLabel} {isSuperAdmin===strings.falseLabel ? userName : strings.superAdminLabel}</p>
            <p className='info-about-version'>{strings.versionLabel} {packageJson.version}</p>
          </div>
        </div>
      
    </div>

  )
}
